ActionNames = require './ActionNames'

module.exports = {
  gamesLoaded: (games) -> {
      type: ActionNames.GamesLoaded
      games
    }

  gameAdded: (game) -> {
      type: ActionNames.GameAdded
      game
    }

  gameRemoved: (gameId) -> {
      type: ActionNames.GameRemoved
      gameId
    }

  roundAdded: (gameId) -> {
      type: ActionNames.RoundAdded
      gameId
    }

  roundUpdated: (gameId, roundNumber, round) -> {
      type: ActionNames.RoundUpdated
      gameId
      roundNumber
      round
    }

  roundRemoved: (gameId, roundNumber) -> {
      type: ActionNames.RoundRemoved
      gameId
      roundNumber
    }

  gamesImported: (games) -> {
      type: ActionNames.GamesImported
      games
    }
}